import { render, staticRenderFns } from "./animat-upload.vue?vue&type=template&id=3b0e7220&scoped=true&"
import script from "./animat-upload.vue?vue&type=script&lang=js&"
export * from "./animat-upload.vue?vue&type=script&lang=js&"
import style0 from "./animat-upload.vue?vue&type=style&index=0&id=3b0e7220&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0e7220",
  null
  
)

export default component.exports